// export default Articles;  

import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/Articles.css';

const Articles = () => {
  const navigate = useNavigate();

  // Parts of the Indian Constitution
  const parts = [
    { part: "Part I", title: "The Union and Its Territory" },
    { part: "Part II", title: "Citizenship" },
    { part: "Part III", title: "Fundamental Rights" },
    { part: "Part IV", title: "Directive Principles of State Policy" },
    { part: "Part IV-A", title: "Fundamental Duties" },
    { part: "Part V", title: "The Union" },
    { part: "Part VI", title: "The States" },
    { part: "Part VII", title: "States in the B part of the first schedule (repealed)" },
    { part: "Part VIII", title: "Union Territories" },
    { part: "Part IX", title: "Panchayats" },
    { part: "Part IX-A", title: "Municipalities" },
    { part: "Part IX-B", title: "Co-operative societies" },
    { part: "Part X", title: "Scheduled and tribal areas" },
    { part: "Part XI", title: "Relations between the Union and the States" },
    { part: "Part XII", title: "Finance, property, contracts and suits" },
    { part: "Part XIII", title: "Trade and commerce within India" },
    { part: "Part XIV", title: "Services under the union and states" },
    { part: "Part XIV-A", title: "Tribunals" },
    { part: "Part XV", title: "Elections" },
    { part: "Part XVI", title: "Special provisions relating to certain classes" },
    { part: "Part XVII", title: "Languages" },
    { part: "Part XVIII", title: "Emergency provisions" },
    { part: "Part XIX", title: "Miscellaneous" },
    { part: "Part XX", title: "Amendment of the Constitution" },
    { part: "Part XXI", title: "Temporary, transitional and special provisions" },
    { part: "Part XXII", title: "Short title, date of commencement, authoritative text in Hindi and repeals" }
  ];

  // Navigate to parts-display page with selected title
  const handlePartClick = (title) => {
    navigate(`/parts-display`, { state: { title } }); // Pass title as state
  };

  return (
    <div className="articles-container">
  <h1 className="articles-title articles-title-visible">Articles and Parts of the Indian Constitution</h1>

      {/* Display Constitution Parts */}
      <div className="articles-list">
        {parts.map((item, index) => (
          <div key={index} className="part-section">
            <button
              className="part-button"
              onClick={() => handlePartClick(item.title)}
            >
              <h2>{item.part}: {item.title}</h2>
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Articles;
